var React = require('react');

function ClutchIconWhite (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clutch_1__clip0)","key":0},[React.createElement("path",{"d":"M17.967 18.426a7.328 7.328 0 01-4.95 1.836c-4.197 0-7.28-3.082-7.28-7.311 0-4.23 2.984-7.18 7.28-7.18A7.508 7.508 0 0118 7.573l.918.787 4.066-4.066-1.017-.95A13.157 13.157 0 0013.017 0C5.474 0 0 5.443 0 12.918S5.607 26 13.016 26a13.16 13.16 0 009.017-3.41l.983-.918-4.13-4.066-.919.82z","fill":"#FAFAFA","key":0}),React.createElement("path",{"d":"M12.82 17.344a4.36 4.36 0 100-8.721 4.36 4.36 0 000 8.721z","fill":"#FF3D2E","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clutch_1__clip0"},React.createElement("path",{"fill":"#fff","d":"M0 0h23.016v26H0z"})))]);
}

ClutchIconWhite.defaultProps = {"width":"24","height":"26","fill":"none"};

module.exports = ClutchIconWhite;

ClutchIconWhite.default = ClutchIconWhite;
